export default __webpack_public_path__ + "static/cmore_banner-124129020a394ad6254be7ad8ff90e73.png";